<template>
	<div class="wd-relative">
		<div class="wd-m-t-20 wd-m-b-20">
			<el-tabs type="border-card">
				<el-tab-pane label="地址管理">
					<el-row class="wd-theme-back wd-h-40 wd-lh-40 wd-theme-333">
						<el-col :span="5" class="wd-text-center">收货人</el-col>
						<el-col :span="8" class="wd-text-center">收货地址</el-col>
						
						<el-col :span="5" class="wd-text-center">联系电话</el-col>
						<el-col :span="6" class="wd-text-center">操作</el-col>
					</el-row>
					<el-row class="wd-theme-333  wd-border-bottom wd-flex wd-p-10" v-for="(item,index) in addrlist" :key="index">
						<el-col :span="5" class="wd-text-center">
							{{item.name}}
						</el-col>
						<el-col :span="8" class="wd-text-center">
							{{item.province}}{{item.addr}}
						</el-col>
						<el-col :span="5" class="wd-text-center">
							{{item.telno}}
						</el-col>
						<el-col :span="6" class="wd-text-center wd-flex wd-row-right">
							<el-button type="primary" size="mini" @click="setdefaultaddr(index)" v-if="item.state!=2">设为默认</el-button>
							<el-button type="" size="mini" @click="editaddr(index)">修改</el-button>
							<el-button type="warning" size="mini" @click="deleteaddr(index)">删除</el-button>
						</el-col>
					</el-row>
				</el-tab-pane>
			</el-tabs>
		</div>
		<div class="add ">
			<el-button type="success" size="mini" @click="editaddr(-1)">新增地址</el-button>
		</div>
		<el-dialog :title="addrtitle" class="addredit" :visible.sync="addrVisible" width="600px" :before-close="addrClose" :close-on-click-modal="false">
			<Addredit :closefun="addrClose" :pid="addrid"></Addredit>
		</el-dialog>
	</div>
</template>

<script>
	import Addredit from '@/views/Member/components/Addredit.vue';
export default {
	name: 'Addrlist',
	components: {
		Addredit
	},
	data(){
		return{
			addrlist:[],
			addrVisible:false,
			addrtitle:'',
			addrid:''
		}
	},
	methods:{
		addrClose(issave=false) {
			if (issave){
				if (this.addrindex==-1){
					this.loadaddrlist();
				}else{
					this.$wd_request("addr",{addrid:this.addrlist[this.addrindex].id},true)
					.then(data=>{
						var addrinfo=data.value;
						addrinfo.select=true;
						this.$set(this.addrlist,this.addrindex,addrinfo);
					})
				}
			}
			this.addrVisible = false;
		},
		loaddata() {
			this.$wd_request('addr', {},true,".memdetail").then(data => {
				this.addrlist = data.value;
			});
		},
		deleteaddr(index){
			this.$confirm("确定删除该地址信息吗？","温馨提示")
			.then(()=>{
				var addrid=this.addrlist[index].id;
				this.$wd_request("deladdr",{addrid:addrid})
				.then(()=>{
					this.addrlist.splice(index,1);
				})
			})
		},
		editaddr(index) {
			this.addrindex=index;
			if (index===-1){
				this.addrtitle="新增收货地址"
				this.addrid = "";
			}else{
				this.addrtitle="修改收货地址"
				this.addrid = this.addrlist[index].id;
			}
			this.addrVisible = true;
		},
		setdefaultaddr(index){
			var addrid=this.addrlist[index].id;
			this.$wd_request("setdefaultaddr",{addrid:addrid},true)
			.then(()=>{
				this.$wd_toast("操作成功");
				for (var i = 0; i < this.addrlist.length; i++) {
					if (i!==index){
						this.addrlist[i].state=0;
					}else{
						this.addrlist[i].state=2;
					}
				}
			})
		}
	},
	created() {
		this.loaddata();
	}
};
</script>

<style lang="scss" scoped>
	.img{
		width: 50px;
		height: 50px;
	}
	.add{
		position: absolute;
		top: 0;
		right: 20px;
		height: 40px;
		line-height: 40px;
	}
</style>
